import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function NotFound() {
  return (
    <div className="mx-auto max-w-xl px-4 py-24 text-center">
      <Helmet><title>Not found · Vyagram</title></Helmet>
      <p className="font-accent italic text-6xl text-amber">404</p>
      <h1 className="mt-2 font-display text-4xl">That page has stepped out.</h1>
      <p className="editorial-body mt-4">But we have a few beautiful stays that haven't.</p>
      <Link to="/stays" className="vyg-cta mt-8 inline-flex">Browse stays</Link>
    </div>
  );
}
